import { render } from "./create_user.vue?vue&type=template&id=98bb0d7e"
import script from "./create_user.vue?vue&type=script&lang=js"
export * from "./create_user.vue?vue&type=script&lang=js"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__